import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";
import { ADD_PLUS_ICON_PATHS } from "mds/utils/toolbar-icons";

export const AddPlusIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {ADD_PLUS_ICON_PATHS.map((d) => (
      <path
        d={d}
        key={d}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    ))}
  </svg>
);
